import {ModuleConfiguration} from "../router/model/UserPermission";
import {CardConfigModuleName} from "../utils/names/optionalModuleNames";

export const CardConfigModuleConfiguration = new ModuleConfiguration(CardConfigModuleName, []);